import React, { useState } from "react";
import { Check } from "lucide-react";
import { DirectionFields, withDirectionDefaults } from "./CharacterDirectionPanel";

const WalkOnsSetupToggle = ({ walkOns, setWalkOns }) => (
  <button
    type="button"
    data-testid="setup-walkons-toggle"
    onClick={() => setWalkOns(v => !v)}
    className={`w-full flex items-start gap-3 p-4 border transition text-left ${walkOns ? "border-rose-800 bg-rose-950/25" : "border-stone-800 bg-stone-900/30 hover:border-stone-600"}`}
  >
    <div className={`mt-0.5 w-4 h-4 border flex items-center justify-center shrink-0 ${walkOns ? "bg-rose-900 border-rose-800" : "border-stone-600 bg-stone-950"}`}>
      {walkOns && <Check className="w-3 h-3 text-rose-50" strokeWidth={2.5} />}
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-sans-ui text-[11px] uppercase tracking-[0.25em] text-stone-300">Allow walk-on characters</div>
      <div className="font-serif-reading italic text-stone-500 text-xs mt-1 leading-relaxed">
        {walkOns
          ? "The AI may give brief lines to waiters, strangers, a cop at the door — max 2 per turn."
          : "Off — only your cast speaks. Good for private, intimate scenes. You can change this later."}
      </div>
    </div>
  </button>
);

// Story-setup section: walk-on switch (scene mode) + optional per-character direction.
export const SetupDirectionSection = ({ mode, aiChars, directions, setDirections, walkOns, setWalkOns }) => {
  const [sel, setSel] = useState("");
  const current = aiChars.find(c => c.id === sel) || aiChars[0];
  return (
    <div className="space-y-4" data-testid="setup-direction-section">
      {mode === "scene" && <WalkOnsSetupToggle walkOns={walkOns} setWalkOns={setWalkOns} />}
      {aiChars.length > 0 && (
        <div className="border border-stone-800 bg-stone-900/30 p-4 space-y-3">
          <div>
            <div className="font-sans-ui text-[11px] uppercase tracking-[0.25em] text-stone-300">Character direction <span className="text-stone-500">(optional)</span></div>
            <div className="font-serif-reading italic text-stone-500 text-xs mt-1">How each character acts in this story. You can change it any time from the reader.</div>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {aiChars.map(c => (
              <button key={c.id} type="button" data-testid={`setup-direction-char-${c.id}`} onClick={() => setSel(c.id)}
                className={`px-3 py-1 rounded-full border text-[11px] font-serif-reading transition ${current?.id === c.id ? "border-rose-800 bg-rose-950/40 text-rose-200" : "border-stone-800 text-stone-400 hover:text-stone-200"}`}>
                {c.name.split(" ")[0]}{directions[c.id]?.notes || directions[c.id]?.mood?.enabled || directions[c.id]?.speech?.enabled ? " •" : ""}
              </button>
            ))}
          </div>
          {current && (
            <div className="space-y-3" data-testid={`setup-direction-editor-${current.id}`}>
              <DirectionFields
                char={current}
                d={withDirectionDefaults(directions[current.id])}
                setD={(d) => setDirections(prev => ({ ...prev, [current.id]: d }))}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
